import apiFetch from '../apiFetch'

export default function (verracosAnadidos, token) {
  return apiFetch({endPoint: `Recta/obtenerVerracos`, method: 'POST', body: verracosAnadidos, token: token})
}